"use client";
import * as React from "react";
const SvgLightbulbRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M6 16c.88 0 1.6-.72 1.6-1.6H4.4c0 .88.72 1.6 1.6 1.6m-2.4-2.4h4.8c.44 0 .8-.36.8-.8s-.36-.8-.8-.8H3.6c-.44 0-.8.36-.8.8s.36.8.8.8M6 0a6 6 0 0 0-2.98 11.2h5.96A6 6 0 0 0 6 0" }));
export {
  SvgLightbulbRound as default
};
